export function changeFontColor(value) {
    return value < 0 ? 'red' : 'green';
  }


// WEBPACK FOOTER //
// ./src/shared/helpers/styles.js